<div class="blog">
  <div class="main">
    <section id="blog" class="section blog-area" style="padding-bottom: 90px; padding-top: 75px; position: relative;">
      <div class="image-frame">
        <img src="https://storage.onindonesia.id/ondelivery.id/shipping-rates.png" alt="shipping rate"
        class="background-image" loading="lazy" style="z-index:-1; width: 100%;" />
      </div>
      <div class="container h-100" style="padding-top: 50px; position: relative;">
        <div class="subscribe-content text-center">
          <h3 style="margin-bottom: 60px; color: white;">{{ translateArr.bp1 }}</h3>
          <!-- <p class="mb-4 text-center">{{ translateArr.bp2 }}</p> -->
          <!-- <p>{{credit |currency :'Rp. ':'symbol':'.0':'id'}}</p> -->
          <div style="position: relative;">
            <mat-tab-group mat-align-tabs="center">
              <mat-tab label="Express">
                <div class="card p-4 p-lg-5">
                  <app-express></app-express>
                </div>
              </mat-tab>
              <!-- <mat-tab label="Trucking">trucking</mat-tab> -->
              <mat-tab label="B2B Logistik">
                <div class="card p-4 p-lg-5">
                  <app-b2b-cost></app-b2b-cost>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    </section>
    <section style="position: relative;">
      <app-navigation-list-bar></app-navigation-list-bar>
    </section>
    <!-- <app-footer-one></app-footer-one> -->
  </div>
</div>